import { assertNever } from 'owa-assert';
import type { SearchableAsset } from './SearchableAsset';
import { trace } from 'owa-trace';

const assets = new Map<string, SearchableAsset>();

export function registerSearchableAsset<SearchResult, Payload>(
    asset: SearchableAsset<SearchResult, Payload>
) {
    const { type } = asset;
    if (assets.has(type)) {
        assertNever(`asset ${type} is already registered` as never);
    }
    assets.set(type, asset as SearchableAsset);
    return asset;
}

export function getSearchableAsset(assetType: string): SearchableAsset | undefined {
    const descriptor = assets.get(assetType);
    if (!descriptor) {
        trace.warn(`unknown asset type: ${assetType}`);
    }
    return descriptor && (!descriptor.isSearchAssetEnabled || descriptor.isSearchAssetEnabled())
        ? descriptor
        : undefined;
}

export function getSearchableAssets(): SearchableAsset[] {
    return [...assets.values()].filter(
        descriptor =>
            !!descriptor && (!descriptor.isSearchAssetEnabled || descriptor.isSearchAssetEnabled())
    );
}

export function getAssetSearchView(assetType: string) {
    const descriptor = getSearchableAsset(assetType);
    return descriptor ? descriptor.SearchView : null;
}
